import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { BuildVersionService } from "../services/build-version.service";

@Injectable()
export class BuildVersionInterceptor implements HttpInterceptor {
  constructor(private readonly buildVersionService: BuildVersionService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.buildVersionService.isEnabled()) {
      return next.handle(req);
    }

    // Ensure build version state is initialized before any HTTP-driven version checks.
    // This prevents first-request false mismatches (e.g., "unknown" -> latest known).
    this.buildVersionService.initialize();
    this.buildVersionService.checkAndReloadIfVersionChanged("http");

    return next.handle(req).pipe(
      tap({
        next: () => this.buildVersionService.checkAndReloadIfVersionChanged("http"),
        error: () => this.buildVersionService.checkAndReloadIfVersionChanged("http"),
      })
    );
  }
}
